export default "__VITE_ASSET__a4ff7cb5__"